import breadcrumbs from 'assets/img/breadcrumbs.svg';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import { IFormMccCard } from 'modules/CustomersAndRestaurants/Customers/EditCustomer/editCustomerState/editCustomerContext';
import React, { useCallback, useState } from 'react';
import style from './AddButton.module.scss';

interface IAddButton {
	mccCards: IFormMccCard[];
	addMccCard: (value: IFormMccCard) => void;
	setShowAdditionalMccCards: (value: boolean) => void;
}

const AddButton: React.FC<IAddButton> = ({ addMccCard, setShowAdditionalMccCards, mccCards }) => {
	const [idCounter, setIdCounter] = useState<number>(1);

	const cardsNumberLimit = mccCards.length >= 9;

	const incrementId = () => {
		setIdCounter((prevState) => prevState + 1);
	};

	const handleClick = useCallback(() => {
		if (cardsNumberLimit) {
			return;
		}
		const newMccCard: IFormMccCard = {
			id: String(idCounter),
			brand: null,
			mcc: null,
		};
		addMccCard(newMccCard);
		incrementId();
		setShowAdditionalMccCards(true);
	}, [addMccCard, idCounter]);

	return (
		<Button
			className={style.button}
			onClick={handleClick}
			iconPosition="post"
			disabled={cardsNumberLimit}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#plus`} />
				</svg>
			}>
			<Text translationNameSpace="form" translationKey="addButton" asFragment={true} />
		</Button>
	);
};

export default React.memo(AddButton);
